// extracted by mini-css-extract-plugin
export default {"wrapper":"ydGmLQB9","input":"aOFCdA5h","content":"ZEXtFSPZ"};